module.exports = __webpack_public_path__ + "static/content-startup-01c06997a786f65b41856117e6c3495c.jpg";